module.exports = __webpack_public_path__ + "media/images/iconLogin-a7983dc43efe8d4721a8e09b0133d317.png";